"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncounterProcedureListProcedure_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Procedure_1 = require("./Procedure");
var EncounterProcedureListProcedure_Factory = /** @class */ (function () {
    function EncounterProcedureListProcedure_Factory() {
    }
    EncounterProcedureListProcedure_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            EncounterProcedureListId: model.EncounterProcedureListId,
            Procedure: Procedure_1.Procedure_Factory.CreateIncoming(model.Procedure),
            ProcedureId: model.ProcedureId,
            Rank: model.Rank,
        };
        return result;
    };
    EncounterProcedureListProcedure_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            EncounterProcedureListId: model.EncounterProcedureListId,
            Procedure: Procedure_1.Procedure_Factory.CreateOutgoing(model.Procedure),
            ProcedureId: model.ProcedureId,
            Rank: model.Rank,
        };
        return result;
    };
    return EncounterProcedureListProcedure_Factory;
}());
exports.EncounterProcedureListProcedure_Factory = EncounterProcedureListProcedure_Factory;
